import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';
import { TabIndex } from '../types';

interface EmptyStateProps {
  activeTab: TabIndex;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getEmptyStateContent = () => {
    switch (activeTab) {
      case TabIndex.REQUIRED:
        return {
          title: t('myCertifications.emptyState.required.title'),
          subtitle: t('myCertifications.emptyState.required.subtitle'),
        };
      case TabIndex.EXPIRED:
        return {
          title: t('myCertifications.emptyState.expired.title'),
          subtitle: t('myCertifications.emptyState.expired.subtitle'),
        };
      case TabIndex.CURRENT:
        return {
          title: t('myCertifications.emptyState.current.title'),
          subtitle: t('myCertifications.emptyState.current.subtitle'),
        };
      default:
        return {
          title: t('myCertifications.emptyState.default.title'),
          subtitle: t('myCertifications.emptyState.default.subtitle'),
        };
    }
  };

  const { title, subtitle } = getEmptyStateContent();

  return (
    <Box className={classes.emptyState} data-testid="my-certifications-empty-state">
      <Typography variant="h6" className={classes.emptyStateTitle} data-testid="my-certifications-empty-state-title">
        {title}
      </Typography>
      <Typography variant="body2" className={classes.emptyStateSubtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};
